import { mapActions, mapState, mapGetters } from "vuex";
import checkPermission from "../../src/service/checkPermission.js";

const ROUTE_PERMISSION_PREFIXES = [
  { prefix: "/setting/baseSetting", key: "basesetting" },
  { prefix: "/setting/pondSetting", key: "pondSetting" },
  { prefix: "/setting/purchaseUnit", key: "purchaseUnit" },
  { prefix: "/buyingAndSelling/fryPurchase", key: "fishPurchase" },
  { prefix: "/buyingAndSelling/fishSales", key: "fishSales" },
  { prefix: "/buyingAndSelling/materialPurchase", key: "materialPurchase" },
  { prefix: "/buyingAndSelling/feedPurchase", key: "materialPurchase" },
  { prefix: "/buyingAndSelling/drugProcurement", key: "materialPurchase" },
  { prefix: "/buyingAndSelling/manureProcurement", key: "materialPurchase" },
  { prefix: "/expense/costOriginValue", key: "costOriginValue" },
  { prefix: "/expense/expenseRecord", key: "expenseRecord" },
  { prefix: "/expense/feeIncome", key: "feeIncome" },
  { prefix: "/productionControl/cultureCycle", key: "cultureCycle" },
  { prefix: "/productionControl/lossManagement", key: "loss" },
  { prefix: "/productionControl/turnPondManagement", key: "turnPond" },
  { prefix: "/productionControl/proofingManagement", key: "proofing" },
  { prefix: "/productionControl/waterQualityParameters/parameterInput", key: "waterParametersInput" },
  { prefix: "/productionControl/feedingManagement", key: "feeding" },
  { prefix: "/productionControl/manureManagement", key: "feeding" },
  { prefix: "/productionControl/preventionManagement", key: "prevention" },
  { prefix: "/backEnd/reportManage", key: "reportManage" },
  { prefix: "/backEnd/certificateManage", key: "certificateManage" },
  { prefix: "/backEnd/circulationBusinessManage", key: "circulationBusinessManage" },
  { prefix: "/backEnd/driverManage", key: "driverManage" },
  { prefix: "/backEnd/qualityCheckManage", key: "qualityCheckManage" },
  { prefix: "/backEnd", key: "traceManagement" },
  // 更长/更具体前缀须排在短前缀之前，避免 startsWith 误匹配
  // 例：contractTemplate 若排在 contract 后，会被当成合同管理(524)，二级企业再被强制只读
  { prefix: "/fishPondLease/propertyAudit", key: "fishPondLeasePropertyAudit" },
  { prefix: "/fishPondLease/property", key: "fishPondLeaseProperty" },
  { prefix: "/fishPondLease/tenantAudit", key: "fishPondLeaseTenantAudit" },
  { prefix: "/fishPondLease/tenant", key: "fishPondLeaseTenant" },
  { prefix: "/fishPondLease/contractTemplate", key: "fishPondLeaseTemplate" },
  { prefix: "/fishPondLease/contract", key: "fishPondLeaseContract" },
  { prefix: "/fishPondLease/rent", key: "fishPondLeaseRent" },
  { prefix: "/fishPondLease/stat", key: "fishPondLeaseStat" },
  { prefix: "/fishPondLease/config", key: "fishPondLeaseConfig" }
];

export default {
  data() {
    return {
      edit: false,
      permission: {
        setting: 100, //设置
        companyManage: 200, //公司管理
        basesetting: 500, //基地设置
        pondSetting: 501, //塘口设置
        cycleBreed: 502, //养殖品种设置
        plantSpecies: 502, //种植品种设置
        companySetting: 503, //公司设置
        peopleManage: 201, //人员管理
        purchaseUnit: 202, //购销单位
        materialSetting: 203, //物资设置
        smartDevice: 101, //智能设备
        waterQualityMonitor: 209, //水质监测
        mapLocation: 210, //地图定位
        videoMonitor: 211, //视频监控
        purchaseMagage: 102, //购销管理
        fishPurchase: 214, //渔苗采购
        fishSales: 215, //成鱼出售
        materialPurchase: 216, //物资采购
        expenseManage: 103, //成本管理
        expenseRecord: 220, //费用记录
        feeIncome: 220, //费用收入
        expenseSetting: 221, //费用设置
        costSummaryTable: 222, //费用分摊汇总表
        costOriginValue: 218, //资产原值
        assetsCalculation: 219, //资产计提
        productionManage: 104, //生产管理
        productPlan: 225, //生产计划
        cultureCycle: 226, //养殖周期
        loss: 227, //损耗管理
        turnPond: 228, //转塘管理
        proofing: 229, //打样管理
        feeding: 235, //投喂管理
        prevention: 236, //防疫防治
        waterParameters: 230, //水质参数
        waterParametersInput: 515, //水质参数录入
        waterParametersLine: 516, //水质参数曲线图
        bigData: 105, //企业大数据平台
        dataAnalyze: 106, //数据分析
        productionReport: 243, //生产报表
        productionProfitReport: 243, //生产利润表
        fishAvgCostReport: 243, //鱼均费用报表
        storagePondReport: 250, //预估存塘报表
        outPondReport: 244, //出塘报表
        goodsLossReport: 246, //物资耗用报表
        lossReport: 245, //损失报表
        stockReport: 247, //库存报表
        inOutReport: 248, //收支报表
        inOutRank: 249, //收支排行榜
        qualityTracingList: 107, //质量追溯
        traceManagement: 107, //追溯管理
        qualityCheckManage: 107, //质检管理
        driverManage: 107, //司机管理
        circulationBusinessManage: 107, //流通商管理
        certificateManage: 107, //证书管理
        reportManage: 107, //报告管理
        fishPondLease: 108, //鱼塘租赁
        fishPondLeaseProperty: 520, //标的物管理
        fishPondLeasePropertyAudit: 521, //标的物审核
        fishPondLeaseTenant: 522, //承租方管理
        fishPondLeaseTenantAudit: 523, //承租方审核
        fishPondLeaseContract: 524, //合同管理
        fishPondLeaseRent: 525, //租金管理
        fishPondLeaseTemplate: 526, //合同模板管理
        fishPondLeaseStat: 527, //鱼塘汇总
        fishPondLeaseConfig: 528, //标的物配置
        deviceManege: 208, //设备管理
        alarmManage: 212
      },
      word: ""
    };
  },
  watch: {
    whetherQlw() {
      this.initPagePermission();
    }
  },
  computed: {
    ...mapState(["loginUser", "inQlw", "curCompany"]),
    getRoute() {
      return this.$route.path;
    },
    sidebar() {
      return this.leftList;
    },
    whetherQlw() {
      return this.curCompany.isQlwVersion;
    }
  },
  mounted() {
    this.initPagePermission();
  },
  methods: {
    getPermissionName(routeName) {
      const matched = ROUTE_PERMISSION_PREFIXES.find(item => routeName.startsWith(item.prefix));
      if (matched) {
        this.activeName = matched.key;
        return;
      }
      switch (routeName) {
        case "/setting/baseSetting":
          this.activeName = "basesetting";
          break;
        case "/setting/pondSetting":
          this.activeName = "pondSetting";
          break;
        case "/setting/cultureBreed":
          this.activeName = "cycleBreed";
          break;
        case "/setting/plantSpecies":
          this.activeName = "plantSpecies";
          break;
        case "/setting/companySetting":
          this.activeName = "companySetting";
          break;
        case "/setting/PersonManagement":
          this.activeName = "peopleManage";
          break;
        case "/setting/purchaseUnit":
          this.activeName = "purchaseUnit";
          break;
        case "/setting/materialSetting":
          this.activeName = "materialSetting";
          break;
        case "/setting/deviceManage":
        case "/smartDevice/deviceManage":
          this.activeName = "deviceManege";
          break;
        case "/smartDevice/alarmManage":
          this.activeName = "alarmManage";
          break;
        case "/smartDevice/waterMonitorIndex":
        case "/tailWaterMonitoring":
          this.activeName = "waterQualityMonitor";
          break;
        case "/smartDevice/mapLocaltion":
          this.activeName = "mapLocation";
          break;
        case "/smartDevice/videoMonitor":
          this.activeName = "videoMonitor";
          break;
        case "/buyingAndSelling/fryPurchase":
          this.activeName = "fishPurchase";
          break;
        case "/buyingAndSelling/fishSales":
          this.activeName = "fishSales";
          break;
        case "/buyingAndSelling/materialPurchase":
        case "/buyingAndSelling/feedPurchase":
        case "/buyingAndSelling/drugProcurement":
        case "/buyingAndSelling/manureProcurement":
          this.activeName = "materialPurchase";
          break;
        case "/expense/costOriginValue":
          this.activeName = "costOriginValue";
          break;
        case "/expense/assetsCalculation":
          this.activeName = "assetsCalculation";
          break;
        case "/expense/expenseRecord":
        case "/expense/ExpenseRecord":
          this.activeName = "expenseRecord";
          break;
        case "/expense/feeIncome":
          this.activeName = "feeIncome";
          break;
        case "/expense/costSummaryTable":
          this.activeName = "costSummaryTable";
          break;
        case "/expense/expenseSetting/detail":
          this.activeName = "expenseSetting";
          break;
        case "/expense/expenseSetting":
          this.activeName = "expenseSetting";
          break;
        case "/productionControl/productionPlan":
          this.activeName = "productPlan";
          break;
        case "/productionControl/cultureCycle":
          this.activeName = "cultureCycle";
          break;
        case "/productionControl/lossManagement":
          this.activeName = "loss";
          break;
        case "/productionControl/turnPondManagement":
          this.activeName = "turnPond";
          break;
        case "/productionControl/proofingManagement":
          this.activeName = "proofing";
          break;
        case "/productionControl/feedingManagement":
        case "/productionControl/feedingManagement/feedingDetail":
        case "/productionControl/manureManagement":
          this.activeName = "feeding";
          break;
        case "/productionControl/preventionManagement":
          this.activeName = "prevention";
          break;
        case "/productionControl/waterQualityParameters/parameterInput":
          this.activeName = "waterParametersInput";
          break;
        case "/productionControl/waterQualityParameters/parameterLine":
          this.activeName = "waterParametersLine";
          break;
        case "/dataAnalyze/productionReport":
          this.activeName = "productionReport";
          break;
        case "/dataAnalyze/productionProfitReport":
        case "/productionProfitReport":
          this.activeName = "productionProfitReport";
          break;
        case "/dataAnalyze/fishAvgCostReport":
        case "/fishAvgCostReport":
          this.activeName = "fishAvgCostReport";
          break;
        case "/dataAnalyze/storagePondReport":
          this.activeName = "storagePondReport";
          break;
        case "/dataAnalyze/outPondReport":
          this.activeName = "outPondReport";
          break;
        case "/dataAnalyze/lossReport":
          this.activeName = "lossReport";
          break;
        case "/dataAnalyze/goodLossSummaryReport":
          this.activeName = "goodsLossReport";
          break;
        case "/dataAnalyze/stockReport":
        case "/dataAnalyze/StockReport":
          this.activeName = "stockReport";
          break;
        case "/dataAnalyze/inOutReport":
        case "/dataAnalyze/InOutReport":
          this.activeName = "inOutReport";
          break;
        case "/dataAnalyze/inOutRank":
        case "/dataAnalyze/InOutRank":
          this.activeName = "inOutRank";
          break;
      }
    },
    /**
     * 统一初始化页面 edit 权限（双版本）
     * @param {object} [route] - 默认当前路由
     * @param {object} [options] - 可传 permissionId 覆盖路由映射
     */
    async initPagePermission(route, options = {}) {
      route = route || this.$route;
      let permissionId = options.permissionId;
      if (permissionId === undefined) {
        this.getPermissionName(route.path);
        permissionId = this.permission[this.activeName];
      }

      this.edit = await checkPermission.initPagePermission(route, {
        ...options,
        permissionId
      });
      // 出租方二级（农发）合同/租金仅查看，与源系统 rental_audit 下 view 页一致
      const enterpriseType = Number(
        this.curCompany && this.curCompany.enterpriseType
      );
      if (
        enterpriseType === 2 &&
        (permissionId === 524 || permissionId === 525)
      ) {
        this.edit = false;
      }
      return this.edit;
    },
    /** @deprecated 请使用 initPagePermission */
    async judgeIsQlw() {
      return this.initPagePermission();
    },
    judgeSession(keyword) {
      let word = sessionStorage.getItem(keyword);
      if (word) {
        this.word = word;
      } else {
        this.word = "";
      }
    }
  }
};
